export default __webpack_public_path__ + "static/media/(92).ec5d2180.jpg";